import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

import getI18nService from '../../i18n/i18n';

const i18n = getI18nService();

function Login({ serviceUrl = '' }) {
  useEffect(() => {
    if (serviceUrl) {
      window.location.href = serviceUrl;
    }
  }, [serviceUrl]);

  return (
    <Box
      height="50%"
      flexGrow="1"
      display="flex"
      overflow="visible"
      mx="auto"
      p={5}
      alignItems="center"
    >
      <Typography variant="h5" color="inherit">
        {i18n.t('Vocabulary.redirectToLogin')}
      </Typography>
    </Box>
  );
}

// Login.propTypes = {
//   serviceUri: PropTypes.string.isRequired,
// };

export default Login;
